import React from "react";
import { Card } from "@material-ui/core";
import VehicleContentUserDataForm from "./VehicleContentUserDataForm/VehicleContentUserDataForm";
import VehicleContentCompanionDataForm from "./VehicleContentCompanionDataForm/VehicleContentCompanionDataForm";
import VehicleContentAssociatedVehicleDataForm from "./VehicleContentAssociatedVehicleDataForm/VehicleContentAssociatedVehicleDataForm";
import "./VehicleContentForm.css";
import AccordionCard from "../../../../../../components/common/PL/AccordionCard/AccordionCard";
import { RegistrationMode } from "../../../registroIngresoNavigation";

const VehicleContentForm = ({
  isAccordion = false,
  vehicles = [],
  disabled = false,
  mode = "entry",
}: {
  isAccordion?: boolean;
  vehicles?: any[];
  disabled?: boolean;
  mode?: RegistrationMode;
}) => {
  if (isAccordion) {
    return (
      <AccordionCard id={`transport-vehicle-section`} titleKey={"Vehículo"} expanded>
        <VehicleContentUserDataForm
          isAccordion={isAccordion}
          vehicles={vehicles}
          disabled={disabled}
          mode={mode}
        />
        <VehicleContentAssociatedVehicleDataForm disabled={disabled} isAccordion={isAccordion} />
      </AccordionCard>
    );
  }

  return (
    <Card className="vehicleContentCard" elevation={0}>
      <VehicleContentUserDataForm vehicles={vehicles} disabled={disabled} mode={mode} />
      <VehicleContentCompanionDataForm disabled={disabled} mode={mode} />
    </Card>
  );
};

export default VehicleContentForm;
